/* eslint-disable */
(function ($) {
  $.Redactor.opts.langs.PT_BR =
    require('transifex/resources/pt_BR.json').redactor;
})(jQuery);
